import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { WhatsAppButton } from '../../components/feature/WhatsAppButton';
import { mockFacilities } from '../../mocks/facilities';

const FacilitiesPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');

  const locations = Array.from(new Set(mockFacilities.map(f => f.location)));

  const filteredFacilities = mockFacilities.filter(facility => {
    const matchesSearch = facility.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         facility.location.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesLocation = !selectedLocation || facility.location === selectedLocation;
    return matchesSearch && matchesLocation;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#0A1628] to-[#1a2d4d]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Tesisler
          </h1>
          <p className="text-xl text-white/80 max-w-3xl">
            Türkiye\'nin en prestijli tatil köylerinde devremülk fırsatları
          </p>
        </div>
      </section>

      {/* Filters Section */}
      <section className="py-8 bg-white border-b border-[#E5E9F0]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <input
                type="text"
                placeholder="Tesis adı veya lokasyon ara..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-6 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
              />
            </div>
            <div className="w-full md:w-64">
              <select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                className="w-full px-6 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors cursor-pointer"
              >
                <option value="">Tüm Lokasyonlar</option>
                {locations.map(location => (
                  <option key={location} value={location}>{location}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Facilities Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="mb-8">
            <p className="text-base text-[#6B7A90]">
              {filteredFacilities.length} tesis bulundu
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredFacilities.map((facility) => (
              <Link
                key={facility.id}
                to={`/tesis/${facility.slug}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-[#E5E9F0] cursor-pointer"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={facility.image}
                    alt={facility.name}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full">
                    <span className="text-sm font-semibold text-[#0A1628]">
                      {facility.listing_count} İlan
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#0A1628] mb-2 group-hover:text-[#D4AF37] transition-colors">
                    {facility.name}
                  </h3>
                  <p className="text-sm text-[#6B7A90] mb-4 flex items-center">
                    <i className="ri-map-pin-line mr-2"></i>
                    {facility.location}
                  </p>
                  <p className="text-sm text-[#6B7A90] mb-4 line-clamp-2">
                    {facility.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {facility.amenities.slice(0, 3).map((amenity, index) => (
                      <span
                        key={index}
                        className="text-xs px-3 py-1 bg-[#F7F9FC] text-[#6B7A90] rounded-full"
                      >
                        {amenity}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center text-[#D4AF37] font-medium">
                    İlanları Gör
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filteredFacilities.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-[#E5E9F0] mb-4"></i>
              <p className="text-xl text-[#6B7A90]">
                Aradığınız kriterlere uygun tesis bulunamadı
              </p>
            </div>
          )}
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default FacilitiesPage;